var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeopleCalendar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "285px",
  height: "132px",
  viewBox: "0 0 285 132",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "0761DAB3-57E5-46B2-B004-9C0F5208A2BB") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 285,
  height: 132
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0.0506385 120.831615 0.0506385 120.831615 28.0251754 0 28.0251754"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0.109330954 0.0647653667 91.7819299 0.0647653667 91.7819299 91.73736 0.109330954 91.73736"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Homepage-English",
  transform: "translate(-45.000000, -576.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15",
  transform: "translate(45.000000, 576.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-208",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M216.931976,15.696981 L224.34702,15.696981 C228.442401,15.696981 231.762195,12.3770556 231.762195,8.2818058 C231.762195,4.18655596 228.442401,0.866630556 224.34702,0.866630556 C220.25177,0.866630556 216.931976,4.18655596 216.931976,8.2818058 L216.931976,15.696981 Z",
  id: "Stroke-1",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-3",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none",
  points: "216.927506 117.433086 216.927506 15.6149401 27.9055509 15.6149401"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.724072,78.655325 L208.183015,72.1143989 C207.02911,70.9604945 207.02911,69.089549 208.183015,67.9356446 L214.724072,61.3947185 C215.877976,60.2406834 217.748791,60.2406834 218.902826,61.3947185 L225.443752,67.9356446 C226.597656,69.089549 226.597656,70.9604945 225.443752,72.1143989 L218.902826,78.655325 C217.748791,79.8092294 215.877976,79.8092294 214.724072,78.655325",
  id: "Fill-5",
  stroke: "none",
  fill: "#FF3F6D",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.9055771,15.6107845 C23.876582,15.6404489 22.0607834,16.9742996 22.0607834,21.4316637 L22.0607834,36.7754559",
  id: "Stroke-7",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.3239953,11.484472 L71.575553,11.484472 C73.7989425,11.484472 75.6180081,13.3035376 75.6180081,15.5269272 L75.6180081,15.6180111 C75.6180081,17.84127 73.7989425,19.6603356 71.575553,19.6603356 L46.3239953,19.6603356 C44.1007364,19.6603356 42.2816708,17.84127 42.2816708,15.6180111 L42.2816708,15.5269272 C42.2816708,13.3035376 44.1007364,11.484472 46.3239953,11.484472",
  id: "Fill-9",
  stroke: "none",
  fill: "#6467EF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.662948,33.2971203 C100.662948,33.2971203 102.418242,50.9930218 122.376214,53.7480175 C141.846227,56.4355824 152.505664,44.0208517 152.505664,44.0208517 L153.486417,46.3546659 L168.18465,45.9623645 C166.614138,46.7720578 164.988348,47.5863249 164.295614,48.3210078 C165.402996,48.1699417 170.175822,47.9173373 176.131693,53.7197907 C182.266727,59.6968325 181.410642,64.3474723 181.410642,64.3474723 L182.445105,64.3474723 C182.445105,64.3474723 209.364401,63.057138 212.054449,45.3224245 C214.744497,27.5875804 199.178549,11.8081011 190.692843,10.3282807 C182.207268,8.84846041 180.104235,6.14469121 162.654534,11.5591557 L151.024145,17.4860164 C151.024145,17.4860164 138.946307,27.7705324 138.763224,27.9902055 C138.580272,28.2097479 133.935905,34.1926703 126.98007,35.3736255 C120.024235,36.5544499 116.474052,32.4799782 116.474052,32.4799782 L110.618019,28.0999767 L100.662948,33.2971203 Z",
  id: "Fill-11",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.962289,19.2428914 C148.962289,19.2428914 153.902385,34.2317567 154.146887,37.9733864 C154.391389,41.7150162 154.501291,40.9464871 154.501291,40.9464871 C154.501291,40.9464871 155.516806,45.503168 153.458073,45.640382 L153.48643,46.3546789 L167.787004,45.9972691 L190.078529,39.080246 L188.703645,36.1977066 C188.703645,36.1977066 183.008741,37.29568 179.501551,33.3977569 C175.994362,29.4998339 172.453456,20.0297156 172.453456,20.0297156 L170.10004,9.50853816 L166.65035,10.2656981 L171.52014,29.1613727 L170.092722,29.7353192 L158.014754,33.7363488 L156.8436,33.960465 L151.432794,17.4415982 L148.962289,19.2428914 Z",
  id: "Fill-13",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.505716,44.0208517 C152.505716,44.0208517 142.972349,54.6714024 126.392585,54.1224157 C109.812952,53.5734291 102.017106,41.5640677 101.454398,37.3231097",
  id: "Stroke-15",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.100134,64.3474593 C218.431881,61.492624 213.463428,38.9334663 210.096327,29.783514 C206.729095,20.6335618 196.041954,5.55452726 172.691268,8.99480894 C149.340712,12.4352213 139.403805,30.1861391 131.443433,33.9604389 C123.48293,37.7348693 117.661789,33.6585681 117.661789,33.6585681",
  id: "Stroke-17",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.862501,49.3453561 C163.862501,49.3453561 163.847865,49.0377353 164.012521,48.7422679 C164.410573,48.0284937 167.979052,47.0128487 174.182823,51.8715311 C179.276599,55.8609302 182.857492,62.5608938 181.237322,64.3336987 C179.971555,65.718776 175.721711,63.8625973 173.832078,62.7869702 C167.32722,59.0842831 163.884586,49.6774139 163.862501,49.3453561",
  id: "Fill-19",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.862501,49.3453561 C163.862501,49.3453561 163.847865,49.0377353 164.012521,48.7422679 C164.410573,48.0284937 167.979052,47.0128487 174.182823,51.8715311 C179.276599,55.8609302 182.857492,62.5608938 181.237322,64.3336987 C179.971555,65.718776 175.721711,63.8625973 173.832078,62.7869702 C167.32722,59.0842831 163.884586,49.6774139 163.862501,49.3453561 Z",
  id: "Stroke-21",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M192.601633,38.42107 C192.601633,38.42107 164.044656,45.6677987 164.012639,48.7421764",
  id: "Stroke-23",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.307097,25.464736 C178.307097,25.464736 186.750332,29.9305944 190.07849,39.0801546",
  id: "Stroke-25",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-27",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none",
  points: "149.560176 35.9322825 153.600932 46.0989251 168.18469 45.9623645"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.962681,19.2269353 C148.902829,19.2718893 158.248148,45.0468204 153.458073,45.640369",
  id: "Stroke-29",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-31",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none",
  points: "151.432833 17.4416374 157.099772 33.9605042 171.520179 29.2710524 166.652349 10.2657373"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.092761,9.4471839 C170.092761,9.4471839 171.65883,23.2790085 178.766908,32.2725368 C182.353551,36.8106611 188.91042,36.420712 188.91042,36.420712",
  id: "Stroke-33",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.010745,9.21753994 C144.010745,9.21753994 148.421979,16.1081657 150.535859,17.1932017 C152.649608,18.2782377 153.993652,18.6549882 155.070978,17.4140509 C156.148173,16.1729829 156.134452,16.667084 156.134452,16.667084 L158.257087,19.747473 C158.257087,19.747473 161.307289,20.7633793 162.261906,19.6897124 C163.216523,18.6160455 163.696903,17.0788567 163.696903,17.0788567 L157.987363,7.64977198 C157.987363,7.64977198 158.261922,6.20876362 157.753969,5.27531638 C157.246146,4.3421305 154.631632,3.44997814 154.631632,3.44997814 L152.497366,4.2186379 L144.010745,9.21753994 Z",
  id: "Fill-35",
  stroke: "none",
  fill: "#FFBA7B",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.875838,11.861327 C156.875838,11.861327 157.389149,17.0869589 153.757814,18.2409939 C150.126478,19.395029 144.010784,9.21753994 144.010784,9.21753994",
  id: "Stroke-37",
  stroke: "#FFBA7B",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("line", {
  x1: 149.208725,
  y1: 10.4806928,
  x2: 151.419308,
  y2: 13.6698075,
  id: "Stroke-39",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("line", {
  x1: 151.948536,
  y1: 8.63394919,
  x2: 152.585862,
  y2: 9.57288499,
  id: "Stroke-41",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("line", {
  x1: 147.565529,
  y1: 11.861327,
  x2: 148.202855,
  y2: 12.8002628,
  id: "Stroke-43",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.910544,16.159536 L158.02168,19.5182733 C158.092116,19.6305274 158.192348,19.7188671 158.313096,19.7730993 C159.129323,20.1399181 162.385869,21.311595 163.928546,17.4842391 C163.983171,17.3489853 163.966052,17.1937375 163.887382,17.071029 L157.692236,7.40593616",
  id: "Stroke-45",
  stroke: "#FFBA7B",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.470634,5.27084712 C154.38543,5.10619032 154.836015,3.6237564 156.65116,4.24605456 C158.466175,4.86822204 158.392994,7.97919012 156.197047,7.86941892",
  id: "Stroke-47",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("line", {
  x1: 138.226626,
  y1: 14.2690145,
  x2: 146.297423,
  y2: 9.63366426,
  id: "Stroke-49",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.875838,3.65527642 C156.509934,2.60826826 150.868348,-2.59018214 145.694466,1.6239865 C140.520452,5.83828582 144.431705,10.6824627 144.431705,10.6824627 C144.431705,10.6824627 156.875838,3.82385362 156.875838,3.65527642",
  id: "Fill-51",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.875838,3.65527642 C156.509934,2.60826826 150.868348,-2.59018214 145.694466,1.6239865 C140.520452,5.83828582 144.431705,10.6824627 144.431705,10.6824627 C144.431705,10.6824627 156.875838,3.82385362 156.875838,3.65527642 Z",
  id: "Stroke-53",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.048185,0.00019602 C149.048185,0.00019602 148.620992,1.89505602 152.055393,6.22735938",
  id: "Stroke-55",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-57",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  points: "171.170362 35.8297379 171.927914 38.2508462 177.617851 36.4556951 176.811164 33.9257303"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.31047,5.74341214 C153.31047,5.74341214 154.671894,7.23812998 154.641576,7.1556709 C154.610997,7.0733425 155.494133,4.50142942 155.494133,4.50142942 L153.31047,5.74341214 Z",
  id: "Fill-59",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.170585,13.1306088 C151.241675,13.0392635 153.860763,12.2888989 154.720768,12.5084413 C154.720768,12.5084413 152.790233,15.4364574 149.862217,15.6377046 C149.862217,15.6377046 150.658189,13.7894973 151.170585,13.1306088",
  id: "Fill-61",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.915902,17.1391263 C155.915902,17.1391263 158.568053,13.8075704 158.358311,11.951261 C159.479677,13.0381266 159.917847,17.9107917 157.548095,19.5492576 L155.915902,17.1391263 Z",
  id: "Fill-63",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-65",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "156.971039 3.71953177 157.163269 4.43317525 156.316985 4.15129849"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.846944,153.547484 C120.846944,156.270725 118.367814,158.478302 115.309641,158.478302 L5.552554,158.478302 C2.49451132,158.478302 0.015381036,156.270725 0.015381036,153.547484 L0.015381036,65.3329956 L120.846944,65.3329956 L120.846944,153.547484 Z",
  id: "Fill-67",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-71",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0.000000, 37.335276)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-70"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.53722523,0.0506385 L115.294312,0.0506385 C118.352354,0.0506385 120.831615,2.25821574 120.831615,4.98145626 L120.831615,28.0251754 L-7.8408e-05,28.0251754 L-7.8408e-05,4.98145626 C-7.8408e-05,2.25821574 2.47918255,0.0506385 5.53722523,0.0506385",
  id: "Fill-69",
  fill: "#252525",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M160.85609,153.547484 C160.85609,156.270725 157.734406,158.478302 153.883658,158.478302 L15.6785813,158.478302 C11.8277031,158.478302 8.70614989,156.270725 8.70614989,153.547484 L8.70614989,65.3329956 L160.85609,65.3329956 L160.85609,153.547484 Z",
  id: "Fill-72",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.85609,153.547484 C160.85609,156.270725 157.734406,158.478302 153.883658,158.478302 L15.6785813,158.478302 C11.8277031,158.478302 8.70614989,156.270725 8.70614989,153.547484 L8.70614989,65.3329956 L160.85609,65.3329956 L160.85609,153.547484 Z",
  id: "Stroke-74",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.678516,37.358537 L153.883593,37.358537 C157.734471,37.358537 160.856024,39.5661143 160.856024,42.2893548 L160.856024,65.3329433 L8.70608455,65.3329433 L8.70608455,42.2893548 C8.70608455,39.5661143 11.8277684,37.358537 15.678516,37.358537",
  id: "Fill-76",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.678516,37.358537 L153.883593,37.358537 C157.734471,37.358537 160.856024,39.5661143 160.856024,42.2893548 L160.856024,65.3329433 L8.70608455,65.3329433 L8.70608455,42.2893548 C8.70608455,39.5661143 11.8277684,37.358537 15.678516,37.358537 Z",
  id: "Stroke-78",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.6001516,51.2392595 C83.6001516,54.1539463 85.9475565,56.5167713 88.8432946,56.5167713 C91.738902,56.5167713 94.0863069,54.1539463 94.0863069,51.2392595 C94.0863069,48.3245728 91.738902,45.9617477 88.8432946,45.9617477 C85.9475565,45.9617477 83.6001516,48.3245728 83.6001516,51.2392595",
  id: "Fill-80",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.950886,48.4136182 L89.9511474,48.4136182 C91.4571037,48.4136182 92.6779162,47.1847034 92.6779162,45.6689461 L92.6779162,34.1932819 C92.6779162,32.8657038 91.7890309,31.6463287 90.4945148,31.3933322 C88.7535958,31.0529108 87.2238558,32.3926422 87.2238558,34.0852096 L87.2238558,37.5678316 L82.6078461,37.5678316 L82.6078461,34.3464389 C82.6078461,30.4133629 85.5497143,26.973604 89.4484214,26.7106758 C93.723879,26.4225264 97.2939259,29.8422913 97.2939259,34.0852096 L97.2939259,45.4294097 C97.2939259,49.2848617 94.4603914,52.672218 90.646365,53.0275369 C90.2382513,53.0655648 89.836149,53.0696159 89.4424101,53.0423038 C86.5358256,52.8409259 86.7765381,48.4136182 89.6900487,48.4136182 L89.950886,48.4136182 Z",
  id: "Fill-82",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.950886,48.4136182 L89.9511474,48.4136182 C91.4571037,48.4136182 92.6779162,47.1847034 92.6779162,45.6689461 L92.6779162,34.1932819 C92.6779162,32.8657038 91.7890309,31.6463287 90.4945148,31.3933322 C88.7535958,31.0529108 87.2238558,32.3926422 87.2238558,34.0852096 L87.2238558,37.5678316 L82.6078461,37.5678316 L82.6078461,34.3464389 C82.6078461,30.4133629 85.5497143,26.973604 89.4484214,26.7106758 C93.723879,26.4225264 97.2939259,29.8422913 97.2939259,34.0852096 L97.2939259,45.4294097 C97.2939259,49.2848617 94.4603914,52.672218 90.646365,53.0275369 C90.2382513,53.0655648 89.836149,53.0696159 89.4424101,53.0423038 C86.5358256,52.8409259 86.7765381,48.4136182 89.6900487,48.4136182 L89.950886,48.4136182 Z",
  id: "Stroke-84",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.625218,51.2392595 C43.625218,54.1539463 45.9726229,56.5167713 48.868361,56.5167713 C51.7639684,56.5167713 54.1113733,54.1539463 54.1113733,51.2392595 C54.1113733,48.3245728 51.7639684,45.9617477 48.868361,45.9617477 C45.9726229,45.9617477 43.625218,48.3245728 43.625218,51.2392595",
  id: "Fill-86",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.9760177,48.4166238 L49.9761484,48.4166238 C51.4822354,48.4166238 52.703048,47.1884932 52.703048,45.6736506 L52.703048,34.2053045 C52.703048,32.8787718 51.8141626,31.6601808 50.5196465,31.407315 C48.7785969,31.067155 47.2489875,32.4059716 47.2489875,34.0974935 L47.2489875,37.5778939 L42.6329779,37.5778939 L42.6329779,34.3584614 C42.6329779,30.4278684 45.574846,26.990331 49.4734225,26.7276642 C53.74888,26.4397762 57.3190576,29.8573195 57.3190576,34.0974935 L57.3190576,45.4342448 C57.3190576,49.2873446 54.4855232,52.6724794 50.6714967,53.0275369 C50.2632524,53.0655648 49.86115,53.0696159 49.4675419,53.0423038 C46.5609573,52.8410566 46.8015392,48.4166238 49.7150498,48.4166238 L49.9760177,48.4166238 Z",
  id: "Fill-88",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.9760177,48.4166238 L49.9761484,48.4166238 C51.4822354,48.4166238 52.703048,47.1884932 52.703048,45.6736506 L52.703048,34.2053045 C52.703048,32.8787718 51.8141626,31.6601808 50.5196465,31.407315 C48.7785969,31.067155 47.2489875,32.4059716 47.2489875,34.0974935 L47.2489875,37.5778939 L42.6329779,37.5778939 L42.6329779,34.3584614 C42.6329779,30.4278684 45.574846,26.990331 49.4734225,26.7276642 C53.74888,26.4397762 57.3190576,29.8573195 57.3190576,34.0974935 L57.3190576,45.4342448 C57.3190576,49.2873446 54.4855232,52.6724794 50.6714967,53.0275369 C50.2632524,53.0655648 49.86115,53.0696159 49.4675419,53.0423038 C46.5609573,52.8410566 46.8015392,48.4166238 49.7150498,48.4166238 L49.9760177,48.4166238 Z",
  id: "Stroke-90",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.93158,51.2392595 C123.93158,54.1539463 126.278985,56.5167713 129.174593,56.5167713 C132.070331,56.5167713 134.417735,54.1539463 134.417735,51.2392595 C134.417735,48.3245728 132.070331,45.9617477 129.174593,45.9617477 C126.278985,45.9617477 123.93158,48.3245728 123.93158,51.2392595",
  id: "Fill-92",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.282315,48.4136182 L130.282576,48.4136182 C131.788402,48.4136182 133.009345,47.1847034 133.009345,45.6689461 L133.009345,34.1932819 C133.009345,32.8657038 132.12046,31.6463287 130.825943,31.3933322 C129.085024,31.0529108 127.555284,32.3926422 127.555284,34.0852096 L127.555284,37.5678316 L122.939275,37.5678316 L122.939275,34.3464389 C122.939275,30.4133629 125.881143,26.973604 129.779719,26.7106758 C134.055177,26.4225264 137.625224,29.8422913 137.625224,34.0852096 L137.625224,45.4294097 C137.625224,49.2848617 134.79182,52.672218 130.977794,53.0275369 C130.569549,53.0655648 130.167447,53.0696159 129.773839,53.0423038 C126.867254,52.8409259 127.107967,48.4136182 130.021477,48.4136182 L130.282315,48.4136182 Z",
  id: "Fill-94",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.282315,48.4136182 L130.282576,48.4136182 C131.788402,48.4136182 133.009345,47.1847034 133.009345,45.6689461 L133.009345,34.1932819 C133.009345,32.8657038 132.12046,31.6463287 130.825943,31.3933322 C129.085024,31.0529108 127.555284,32.3926422 127.555284,34.0852096 L127.555284,37.5678316 L122.939275,37.5678316 L122.939275,34.3464389 C122.939275,30.4133629 125.881143,26.973604 129.779719,26.7106758 C134.055177,26.4225264 137.625224,29.8422913 137.625224,34.0852096 L137.625224,45.4294097 C137.625224,49.2848617 134.79182,52.672218 130.977794,53.0275369 C130.569549,53.0655648 130.167447,53.0696159 129.773839,53.0423038 C126.867254,52.8409259 127.107967,48.4136182 130.021477,48.4136182 L130.282315,48.4136182 Z",
  id: "Stroke-96",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.705643,92.325041 L132.8786,92.325041 C133.928221,92.325041 134.779209,91.4740529 134.779209,90.4244311 L134.779209,77.1634167 C134.779209,76.113795 133.928221,75.2628068 132.8786,75.2628068 L116.705643,75.2628068 C115.65589,75.2628068 114.805033,76.113795 114.805033,77.1634167 L114.805033,90.4244311 C114.805033,91.4740529 115.65589,92.325041 116.705643,92.325041",
  id: "Fill-98",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.705643,92.325041 L132.8786,92.325041 C133.928221,92.325041 134.779209,91.4740529 134.779209,90.4244311 L134.779209,77.1634167 C134.779209,76.113795 133.928221,75.2628068 132.8786,75.2628068 L116.705643,75.2628068 C115.65589,75.2628068 114.805033,76.113795 114.805033,77.1634167 L114.805033,90.4244311 C114.805033,91.4740529 115.65589,92.325041 116.705643,92.325041 Z",
  id: "Stroke-100",
  strokeOpacity: 0.500464379,
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.705643,118.824371 L132.8786,118.824371 C133.928221,118.824371 134.779209,117.973382 134.779209,116.923761 L134.779209,103.662616 C134.779209,102.612994 133.928221,101.762136 132.8786,101.762136 L116.705643,101.762136 C115.65589,101.762136 114.805033,102.612994 114.805033,103.662616 L114.805033,116.923761 C114.805033,117.973382 115.65589,118.824371 116.705643,118.824371",
  id: "Fill-102",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.705643,118.824371 L132.8786,118.824371 C133.928221,118.824371 134.779209,117.973382 134.779209,116.923761 L134.779209,103.662616 C134.779209,102.612994 133.928221,101.762136 132.8786,101.762136 L116.705643,101.762136 C115.65589,101.762136 114.805033,102.612994 114.805033,103.662616 L114.805033,116.923761 C114.805033,117.973382 115.65589,118.824371 116.705643,118.824371 Z",
  id: "Stroke-104",
  strokeOpacity: 0.500409747,
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9141106,92.325041 L95.0870674,92.325041 C96.1366891,92.325041 96.9876773,91.4740529 96.9876773,90.4244311 L96.9876773,77.1634167 C96.9876773,76.113795 96.1366891,75.2628068 95.0870674,75.2628068 L78.9141106,75.2628068 C77.8643581,75.2628068 77.0135007,76.113795 77.0135007,77.1634167 L77.0135007,90.4244311 C77.0135007,91.4740529 77.8643581,92.325041 78.9141106,92.325041",
  id: "Fill-110",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9141106,92.325041 L95.0870674,92.325041 C96.1366891,92.325041 96.9876773,91.4740529 96.9876773,90.4244311 L96.9876773,77.1634167 C96.9876773,76.113795 96.1366891,75.2628068 95.0870674,75.2628068 L78.9141106,75.2628068 C77.8643581,75.2628068 77.0135007,76.113795 77.0135007,77.1634167 L77.0135007,90.4244311 C77.0135007,91.4740529 77.8643581,92.325041 78.9141106,92.325041 Z",
  id: "Stroke-112",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-118",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(76.970520, 101.760516)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.94359057,17.0638546 L18.1165474,17.0638546 C19.1661691,17.0638546 20.0171573,16.2128665 20.0171573,15.1632447 L20.0171573,1.90209967 C20.0171573,0.852477912 19.1661691,0.001620432 18.1165474,0.001620432 L1.94359057,0.001620432 C0.893838132,0.001620432 0.042980652,0.852477912 0.042980652,1.90209967 L0.042980652,15.1632447 C0.042980652,16.2128665 0.893838132,17.0638546 1.94359057,17.0638546",
  id: "Fill-114",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.94359057,17.0638546 L18.1165474,17.0638546 C19.1661691,17.0638546 20.0171573,16.2128665 20.0171573,15.1632447 L20.0171573,1.90209967 C20.0171573,0.852477912 19.1661691,0.001620432 18.1165474,0.001620432 L1.94359057,0.001620432 C0.893838132,0.001620432 0.042980652,0.852477912 0.042980652,1.90209967 L0.042980652,15.1632447 C0.042980652,16.2128665 0.893838132,17.0638546 1.94359057,17.0638546 Z",
  id: "Stroke-116",
  strokeOpacity: 0.49838833,
  stroke: "#252525",
  strokeWidth: 0.4
})), /*#__PURE__*/React.createElement("path", {
  d: "M38.9901552,92.325041 L55.1632427,92.325041 C56.2128645,92.325041 57.0638526,91.4740529 57.0638526,90.4244311 L57.0638526,77.1634167 C57.0638526,76.113795 56.2128645,75.2628068 55.1632427,75.2628068 L38.9901552,75.2628068 C37.9405335,75.2628068 37.0895453,76.113795 37.0895453,77.1634167 L37.0895453,90.4244311 C37.0895453,91.4740529 37.9405335,92.325041 38.9901552,92.325041",
  id: "Fill-124",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.9901552,92.325041 L55.1632427,92.325041 C56.2128645,92.325041 57.0638526,91.4740529 57.0638526,90.4244311 L57.0638526,77.1634167 C57.0638526,76.113795 56.2128645,75.2628068 55.1632427,75.2628068 L38.9901552,75.2628068 C37.9405335,75.2628068 37.0895453,76.113795 37.0895453,77.1634167 L37.0895453,90.4244311 C37.0895453,91.4740529 37.9405335,92.325041 38.9901552,92.325041 Z",
  id: "Stroke-126",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.9901552,118.824371 L55.1632427,118.824371 C56.2128645,118.824371 57.0638526,117.973382 57.0638526,116.923761 L57.0638526,103.662616 C57.0638526,102.612994 56.2128645,101.762136 55.1632427,101.762136 L38.9901552,101.762136 C37.9405335,101.762136 37.0895453,102.612994 37.0895453,103.662616 L37.0895453,116.923761 C37.0895453,117.973382 37.9405335,118.824371 38.9901552,118.824371",
  id: "Fill-128",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.9901552,118.824371 L55.1632427,118.824371 C56.2128645,118.824371 57.0638526,117.973382 57.0638526,116.923761 L57.0638526,103.662616 C57.0638526,102.612994 56.2128645,101.762136 55.1632427,101.762136 L38.9901552,101.762136 C37.9405335,101.762136 37.0895453,102.612994 37.0895453,103.662616 L37.0895453,116.923761 C37.0895453,117.973382 37.9405335,118.824371 38.9901552,118.824371 Z",
  id: "Stroke-130",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.062595,84.9954743 C154.934561,87.5275299 146.349669,83.1740564 143.88805,75.2714448 C141.4263,67.3690945 146.019702,58.9103088 154.147867,56.3782531 C162.275902,53.8461974 170.860794,58.1998016 173.322544,66.1021519 C175.784293,74.0046329 171.190761,82.4634186 163.062595,84.9954743 M153.816724,55.315302 C145.084817,58.0354062 140.150079,67.122632 142.79465,75.6121275 C145.439352,84.1014924 154.661832,88.7785296 163.393739,86.0584254 C172.125646,83.3381905 177.060384,74.2510953 174.415813,65.7615998 C171.771241,57.2721043 162.548631,52.5951978 153.816724,55.315302",
  id: "Fill-137",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-139",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "169.000107 85.0675835 159.337366 88.0776666 156.52461 79.0482013 166.18735 76.0381182"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-141",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "140.838436 104.345301 138.46973 108.17527 132.950591 104.761648 135.319297 100.931809"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-145",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(131.594760, 83.595996)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-144"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.6959816,32.2721317 C97.2231496,56.434733 83.7372349,82.1243301 59.5746336,89.6514981 C35.4120323,97.1785354 9.72243518,83.6926208 2.19526718,59.5300195 C-5.33190082,35.3674182 8.1541445,9.67782103 32.3167458,2.15065303 C56.4793471,-5.37638429 82.1689443,8.10953035 89.6959816,32.2721317",
  id: "Fill-143",
  fill: "#252525",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M216.077446,117.49218 C222.707496,138.775508 210.828814,161.403927 189.545355,168.034107 C168.262026,174.664287 145.633477,162.785475 139.003297,141.501885 C132.373247,120.218556 144.252059,97.5901382 165.535388,90.9600884 C186.818847,84.3299079 209.447396,96.2087199 216.077446,117.49218",
  id: "Fill-146",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M213.883708,118.175571 C220.136484,138.247365 208.933811,159.587671 188.861885,165.840316 C168.790091,172.093093 147.449785,160.890419 141.197009,140.818625 C134.944363,120.74683 146.146906,99.4065249 166.218831,93.1537482 C186.290756,86.9011023 207.630931,98.1036453 213.883708,118.175571",
  id: "Fill-148",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M213.883708,118.175571 C220.136484,138.247365 208.933811,159.587671 188.861885,165.840316 C168.790091,172.093093 147.449785,160.890419 141.197009,140.818625 C134.944363,120.74683 146.146906,99.4065249 166.218831,93.1537482 C186.290756,86.9011023 207.630931,98.1036453 213.883708,118.175571 Z",
  id: "Stroke-150",
  stroke: "#252525",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-156",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "169.128617 96.4588153 165.701012 97.5266016 164.633225 94.0988652 168.060831 93.0312096"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-162",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "209.510776 117.657568 210.578562 121.085174 214.006299 120.017518 212.938382 116.589782"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-164",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "153.73633 105.091223 151.301761 107.729652 148.663202 105.295345 151.09777 102.656654"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-170",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "199.307661 103.258396 201.94622 105.692965 204.380789 103.054274 201.742229 100.619836"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-172",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "144.728466 120.241817 143.937068 123.743649 140.435236 122.952251 141.226634 119.450419"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-178",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd",
  points: "183.293872 95.8938596 186.795704 96.6852576 187.587102 93.183295 184.08527 92.3918969"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.566476,78.1111734 L154.097399,83.2416702 C153.326387,83.4818601 152.506631,83.0515308 152.266441,82.2803882 L150.323491,76.0431624 C150.083301,75.2721504 150.51363,74.4523948 151.284642,74.212205 L167.75372,69.0818388 C168.524732,68.841649 169.344357,69.2719782 169.584547,70.0429902 L171.527628,76.280216 C171.767818,77.051228 171.337488,77.8709836 170.566476,78.1111734",
  id: "Fill-180",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.969999,100.801887 L134.500482,108.02836 C134.208935,108.499592 133.590688,108.645431 133.119325,108.353884 L129.306867,105.995894 C128.835504,105.704478 128.689796,105.085969 128.981212,104.614737 L133.45086,97.3882638 C133.742277,96.916901 134.360654,96.7711928 134.831887,97.0627399 L138.644476,99.4207298 C139.115708,99.7121462 139.261416,100.330655 138.969999,100.801887",
  id: "Fill-182",
  stroke: "none",
  fill: "#252525",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.814501,57.3849203 L173.894138,58.7812361 C173.894138,58.7812361 174.520095,64.4162884 171.133523,64.7588007 C170.526906,64.8200896 169.691861,63.8686085 169.691861,63.8686085 C169.691861,63.8686085 169.206908,64.937963 167.945454,64.8790263 C166.683869,64.8200896 166.574098,63.8686085 166.574098,63.8686085 C166.574098,63.8686085 165.805438,65.0809269 164.6663,64.9985985 C163.527163,64.9162701 163.719262,63.3928027 163.719262,63.3928027 C163.719262,63.3928027 163.788,65.437814 161.962531,65.0809269 C160.137062,64.7240398 160.134187,55.9629913 160.134187,55.9629913 L164.117314,50.6377813 L166.809191,48.3442166 C166.809191,48.3442166 173.519478,49.596131 178.814501,57.3849203",
  id: "Fill-188",
  stroke: "none",
  fill: "#FFBA7B",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.757102,48.4325824 C166.757102,48.4325824 160.498445,53.2912648 160.205722,57.0975812 C159.912998,60.9040282 160.498445,64.9300176 162.328488,64.9300176 C163.426592,64.9300176 163.755905,63.9782752 163.755905,63.9782752 C163.755905,63.9782752 164.817288,66.0645814 166.757102,63.9418155 C166.757102,63.9418155 167.855075,66.1377622 169.904661,63.8686347 C169.904661,63.8686347 171.295488,65.9180891 172.869267,63.9050944 C174.443046,61.8922304 173.89406,58.7811316 173.89406,58.7811316 L178.814554,57.3849465",
  id: "Stroke-190",
  stroke: "#FFBA7B",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("line", {
  x1: 163.353306,
  y1: 57.5367836,
  x2: 163.797749,
  y2: 64.6487812,
  id: "Stroke-192",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("line", {
  x1: 167.013366,
  y1: 57.9027921,
  x2: 166.733188,
  y2: 64.5044844,
  id: "Stroke-194",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("line", {
  x1: 170.197541,
  y1: 58.3786111,
  x2: 169.87071,
  y2: 64.5044974,
  id: "Stroke-196",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.584456,40.4542739 C102.584456,40.4542739 100.975915,40.6684584 100.590017,39.5270993 C100.204119,38.3857401 98.7913379,30.4436631 102.988257,29.7223095 C107.185176,29.0010866 108.072493,29.1086363 108.072493,29.1086363 L111.98649,29.9526984 L115.497861,31.9049269 C115.497861,31.9049269 119.47563,36.1580382 118.362759,36.7527629 C117.249888,37.3476182 114.24856,35.7371179 113.297079,34.3464213 C113.297079,34.3464213 111.974859,41.2664501 108.868465,40.9155743 L108.038124,40.4242175 C108.038124,40.4242175 106.816658,41.0968274 106.466697,40.9869255 C106.116605,40.8771543 105.183419,40.2251918 105.183419,40.2251918 C105.183419,40.2251918 104.407964,40.9937209 103.728559,40.8153427 C103.049154,40.6369645 102.584456,40.4542739 102.584456,40.4542739",
  id: "Fill-198",
  stroke: "none",
  fill: "#FFBA7B",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.425146,34.3097656 C113.425146,34.3097656 115.327585,36.9454505 117.667541,37.0475116 C118.33218,37.0765226 118.786293,36.3873162 118.493177,35.7902393 C117.741767,34.2593231 115.999411,31.4792368 112.903602,30.4668588 C112.903602,30.4668588 110.95464,29.0943268 109.280237,29.5335423 C109.280237,29.5335423 107.550949,28.6276685 106.150974,29.1766552 C106.150974,29.1766552 104.476441,28.7923253 103.296139,29.6158707 C103.296139,29.6158707 101.347308,30.219743 100.770879,31.1256167 C100.194318,32.0313598 99.1317593,39.0984035 101.319735,40.3487498 C102.088394,40.7879652 102.829481,40.3487498 102.829481,40.3487498 C102.829481,40.3487498 103.817683,41.6388227 105.327429,40.1566502 C105.327429,40.1566502 106.535304,41.7487246 108.072493,40.321307 C108.072493,40.321307 109.637125,41.6662655 111.064542,40.1016339 C112.491829,38.5370022 113.740738,33.9986165 113.452588,32.2784757",
  id: "Stroke-200",
  stroke: "#FFBA7B",
  strokeWidth: 0.605,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.719722,40.8703067 C102.445164,37.3841564 103.104052,33.6510208 103.104052,33.6510208",
  id: "Stroke-202",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.986278,33.3490062 C105.986278,33.3490062 105.206903,39.6076635 105.316674,40.8702936",
  id: "Stroke-204",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.868517,33.6510077 C108.868517,33.6510077 108.072414,39.0585461 108.072414,40.8702936",
  id: "Stroke-206",
  stroke: "#252525",
  strokeWidth: 0.4,
  fill: "none"
}))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeopleCalendar);
export default ForwardRef;